(function ($) {

    'use strict';

    window.$html = $(html);

    window.$body = $html.find('body');

    // 购物车相关
    class CartData {
        constructor() {
            this.rootURL = window.langify && window.langify.locale.root_url != '/' ? window.langify.locale.root_url + '/cart' : theme.routes.cart_url;
            this.currentData = {
                items: []
            };

            // fbt
            this.fbtPrice = { price: 0, compare_at_price: 0 };
            this.currentFbtData = [];
            this.subscribeFbt();
            this.subscribeVariantSwitch();
        }
        //订阅fbt
        subscribeFbt() {
            document.addEventListener('fbt::product::change', e => {
                const { items, action } = e.detail;
                this.currentFbtData = items;
                
                const sumPrices = this.currentFbtData.reduce(
                    (acc, obj) => {
                      const price = Number(obj.variant.price);
                      const comparePrice = Number(obj.variant.compare_at_price);
                  
                      acc.sumPrice += price * 100;
                      acc.sumComparePrice += comparePrice * 100;
                  
                      return acc;
                    },
                    { sumPrice: 0, sumComparePrice: 0 }
                );
                  
                const { sumPrice, sumComparePrice } = sumPrices;
                this.fbtPrice.price = sumPrice;
                this.fbtPrice.compare_at_price = sumComparePrice;
                window.__fbt_price = this.fbtPrice;

                this.afterSelectedFbtUpdatePrice({
                    fbtPrice: this.fbtPrice,
                    carePrice: window.__care_price
                });
                console.log(this.currentFbtData, 'this.currentFbtData', 'fbtItems');
            })
        }
        // 更新价格
        afterSelectedFbtUpdatePrice(params) {
            const {
                carePrice,
                fbtPrice,
            } = params
            const $product = $('#product-page-main');
            const $cloneId = $product.attr('data-js-product-clone-id');
            const $cloneProduct = $('[data-js-product-clone="' + $cloneId + '"]');
            const json = $product.attr('data-json-product') && JSON.parse($product.attr('data-json-product'));
            const updatePriceNeedData = {
                update_variant: __Xtool_Utils.getCurrentVariant(),
                json: json || window.makeblock?.product?.json,
                has_unselected_options: false
            }

            theme.ProductOptions._updateLabelSale($product, updatePriceNeedData);
            theme.ProductOptions._updatePrice($product, $cloneProduct, updatePriceNeedData, {price: carePrice}, fbtPrice);
        }
        // 监听变体切换
        subscribeVariantSwitch() {
            document.addEventListener('theme:product::switchVariant', e => {
                this.currentFbtData = [];
                if (this.currentFbtData.length === 0 || this.currentFbtData.every(item => item === 1)) return
                this.afterSelectedFbtUpdatePrice({
                    fbtPrice: this.fbtPrice,
                    carePrice: window.__care_price
                })
            })
        }
        setCurrentData(data) {
            this.currentData = data;
            localStorage.setItem('cartCurrentData', JSON.stringify(this.currentData));
            return this.currentData;
        }

        addItem(item, entrance) {
            this.addItems([item], entrance);
        }

        addItems(items, entrance) {
            /**
             * 处理care相关逻辑
             */
            const isXtoolCareSelected = $('.xtool-care__content').hasClass('xtool-care__content--selected');
            const careVariantId = $('input[name="care_variant_id"]').val();
            const quantity = $('input[name="quantity"]').val() || 1;
            const updatedItems = isXtoolCareSelected && careVariantId ? [...items, { id: careVariantId, quantity }] : items;
            const latestCurrentFbtData = entrance === 'winback' ? [] : this.currentFbtData;

            const latestItems = [...updatedItems, ...latestCurrentFbtData];
            
            const addCartList = latestItems.map(v => ({
                merchandiseId: v.id,
                quantity: quantity,
            }));
            document.dispatchEvent(new CustomEvent('cart::product::add', {
                bubbles: true,
                composed: true,
                detail: {
                    items: addCartList,
                    entrance: entrance
                }
            }));
        }

        // 暂未使用，需要再打开
        // getPageContent() {
        //     const requestParams = {
        //         method: 'GET'
        //     };

        //     return fetch(`${this.rootURL}?view=ajax`, requestParams)
        //         .then(response => response.text())
        //         .catch(error => console.error('Error:', error));
        // }

        // getPopupContent() {
        //     const requestParams = {
        //         method: 'GET'
        //     };

        //     return fetch(`${this.rootURL}?view=popup`, requestParams)
        //         .then(response => response.text())
        //         .catch(error => console.error('Error:', error));
        // }
    };

    class CartViewer extends CartData {
        constructor() {
            super();
            this.subscribeCartChange();
            this.subscribeCartError();
        }

        updateCart() {
            document.dispatchEvent(
                new CustomEvent('cart::product::forceupdate', {
                    bubbles: true,
                    composed: true,
                }),
            );
        }

        // 订阅购物车数量变化
        subscribeCartChange() {
            document.addEventListener('on::cart::change', e => {
                this.currentData = e.detail;
                this.setCurrentData(this.currentData);
                const $btns = this.mergeWithDuplicateButtons($(this.selectorButtonAdd));
                // TODO 可点击按钮判断
                this.enableButton($btns);
            });
        }
        // 订阅购物车报错
        subscribeCartError() {
            document.addEventListener('on::cart::change::error', e => {
                const $btns = this.mergeWithDuplicateButtons($(this.selectorButtonAdd));
                this.enableButton($btns);
            });
        }
    }

    class CartController extends CartViewer {
        constructor() {
            super();

            this.selectorButtonAdd = '.js-product-button-add-to-cart';

            this.addToCartController();

            this.footerAddCartClick = false;

            this.hasChangedBtnStatus = false;
        }

        addToCartController() {
            const _ = this;
            // 监听点击加购按钮
            $(document).on('click', this.selectorButtonAdd, function (e) {
                const $this = $(this);
                const attrButtonStatus = $this.attr('data-button-status');
                if (window.AstroCart && attrButtonStatus !== 'added' && !$this.hasClass('active')) {
                    const $product = $this.parents('[data-js-product]');
                    const $btns = _.mergeWithDuplicateButtons($this);
                    const addToCartEntrance = _.updateFormAddToCartProps($this);
                    _.footerAddCartClick = false;

                    // 当按钮状态不是notify me的时候,则需要走care弹框以及弹出小购物车的逻辑
                    if(attrButtonStatus != 'notify-me'){
                        /***添加care弹窗挽留逻辑**/
                        const isXtoolCareSelected = $('.xtool-care__content').hasClass('xtool-care__content--selected');
                        const isNoXtoolCareSelected = $('.not-xtool-care').hasClass('xtool-care__content--selected');
                        const openCareModal = !isXtoolCareSelected || isNoXtoolCareSelected;
                        if (openCareModal) {
                            if (window.__care__detainmentModal_open && window.openDetainmentDialog) {
                                window.openDetainmentDialog();
                                if (!(window.detainmentModal && window.detainmentModal.checkModalStatus())) {
                                    _.showPopup();  // 弹出小购物车
                                }
                            } else {
                                _.showPopup(); // 弹出小购物车
                            }  
                        } else {
                            _.showPopup();  // 弹出小购物车
                        }
                        /***添加care弹窗挽留逻辑 end**/   
                    }
                  
                    if (attrButtonStatus === 'select') {
                        _.disableButton($btns);
                        _.goToProductPage($product);
                    } else if(attrButtonStatus === 'notify-me'){
                        // 到货提醒功能
                        _.showNotifyMeModal($this);
                    } else {
                        const $form = $this.parents('form');
                        const formData = _.serializeForm($form);
                        _.disableButton($btns);
                        _.addItem(formData, addToCartEntrance);
                    }
                }
                e.preventDefault();
            });

            // 详情页底部加购按钮点击、集合页、搜索页加购按钮点击
            $body.on('click', `[data-js-product-button-add-to-cart]:not(${this.selectorButtonAdd})`, function (e) {
                const $this = $(this);
                const attrButtonStatus = $this.attr('data-button-status');
                // 如果是a标签，集合页加购按钮会出现这种情况
                if($this.get(0).tagName == 'A'){
                    if(attrButtonStatus == 'notify-me'){
                        e.preventDefault();
                        // 到货提醒功能
                        _.showNotifyMeModal($this);
                    }
                } else {
                    // 否则默认是button按钮点击
                    _.footerAddCartClick = true;
                    const $btns = _.mergeWithDuplicateButtons($this);
                    if(attrButtonStatus != 'notify-me'){
                        setTimeout(() => _.disableButton($btns), 100);
                    }  
                }
            });
        }

        // 到货提醒订阅弹窗
        showNotifyMeModal($btn){
            const $product = $btn.parents('[data-js-product]');
            const product_id = +$product.attr('data-product-id');
            const variant_id = +$product.attr('data-product-variant-id');
            const handle = $product.attr('data-product-handle');
            try {
                $.getJSON('/products/'+ handle + '.js', function (product) {
                    const variants = product.variants;
                    document.dispatchEvent(new CustomEvent('theme:notifyme::openmodal', {
                        detail: {
                            product_id,
                            variant_id,
                            variants
                        }
                    }));
                });    
            } catch (err) {
                console.log('error',err);
            }
        }
        
        mergeWithDuplicateButtons($btn) {
            const cloneId = $btn.attr('data-js-button-add-to-cart-clone-id');
            const _ = this;

            if (cloneId !== undefined) {
                $btn = $btn.add($(`[data-js-button-add-to-cart-clone="${cloneId}"]`));
            }

            return $btn;
        }

        updateFormAddToCartProps($btn) {
            const _ = this;
            const $product = $btn.parents('[data-js-product]');
            let addToCartEntrance = '';
            if (_.footerAddCartClick) {
                $product.attr('data-add-to-cart-form', 'product_bottom');
                addToCartEntrance = 'product_bottom';
            } else {
                $product.attr('data-add-to-cart-form', 'product_first');
                addToCartEntrance = 'product_first';
            }
            // 产品页的ymal产品
            if ($product && $product.parents('carousel-products').length > 0) {
                $product.attr('data-add-to-cart-form', 'product_ymal');
                addToCartEntrance = 'product_ymal';
            }
            return addToCartEntrance;
        }

        disableButton($btns) {
            this.hasChangedBtnStatus = true;
            if (window.AstroCart) {
                $btns.addClass('active').attr('disabled', 'disabled');
            }
        }

        // statusButtonAdded($btns) {
        //     $btns.each(function () {
        //         const $this = $(this),
        //             btnWidth = $this.outerWidth();

        //         $this.css({
        //             'min-width': `${btnWidth}px`
        //         });
        //     });

        //     $btns.removeAttr('disabled').attr('data-button-status', 'added');
        // }

        enableButton($btns) {
            if (this.hasChangedBtnStatus) {
                this.hasChangedBtnStatus = false;
                $btns.removeAttr('disabled').removeClass('active');
                return;
            }
            this.hasChangedBtnStatus = false;
        }

        showPopup() {
            window.AstroCart && document.dispatchEvent(new CustomEvent('cart::popup::open'));
        }

        goToProductPage($product) {
            location.href = '/products/' + $product.attr('data-product-handle');
        }

        serializeForm($form, serialize_obj = { quantity: 1 }) {
            $form.serializeArray().forEach(obj => {
                if (['id', 'quantity', 'selling_plan', 'purchase_option'].includes(obj.name)) {
                    serialize_obj[obj.name] = obj.value;
                } else if (obj.name.indexOf('properties') !== -1 && obj.value !== '') {
                    serialize_obj.properties = serialize_obj.properties || {};
                    serialize_obj.properties[obj.name.replace('properties[', '').replace(']', '')] = obj.value;
                }
            });
            return serialize_obj;
        }
    };

    theme.AssetsLoader.onPageLoaded(function () {
        theme.Cart = new CartController;
    });
})(jQueryTheme);